import { render, staticRenderFns } from "./PageThreeView.vue?vue&type=template&id=bf41ddbe"
import script from "./PageThreeView.vue?vue&type=script&lang=js"
export * from "./PageThreeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports